import { optionSubcategory_automaticReplies } from 'owa-locstrings/lib/strings/optionsubcategory_automaticreplies.locstring.json';
import AutomaticRepliesOption from 'owa-automatic-replies-option/lib/AutomaticRepliesOption';
import { OptionSubCategory } from 'owa-options-core';
import { initLoadMailboxAutomaticRepliesConfiguration } from 'owa-automatic-replies-option';

const automaticRepliesSubCategory: OptionSubCategory = {
    key: 'automaticReplies',
    titleStringKey: optionSubcategory_automaticReplies,
    options: [AutomaticRepliesOption],
    onSelected: () => {
        return initLoadMailboxAutomaticRepliesConfiguration();
    },
    refreshOnSelected: true,
};

export default automaticRepliesSubCategory;
